<template>
    <div class="container compact-padding">
        <h1 class="heading--lg heading">PERKS<br/>& BENEFITS</h1>
        <div class="divider"></div>
        <div class="perksGrid--wrapper">
            <grid-asset  v-for="(asset, index) in assets" :key="asset.id" :img-src="asset.img"
                        :heading="asset.heading"
                        :text="asset.text" class="grid__asset"></grid-asset>
        </div>
    </div>
</template>

<script>
    import GridAsset from "../GridAsset";
    import assets from '../../assets/data/perksData';

    export default {
        components: {GridAsset},
        name: "PerksGrid",
        data() {
            return {assets}
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";

    .perksGrid--wrapper {

        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        grid-gap: 58px;

        @media (max-width: 1200px) {
            grid-gap: 30px;
        }
    }

    .container {
        margin-bottom: 200px;
        margin-top: 60px;
        @media (max-width: 1200px) {
            margin-top: 30px;
        }
        @media (max-width: $compact) {
            margin-bottom: 50px;
        }
    }

    .heading {
        margin-bottom: 96px;
        @media (max-width: $compact) {
            margin-bottom: 16px;
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/landingPageComponents/PerksGrid.vue